import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selector", "avatarWrap", "avatarImg", "tierBadge"]
  static values = {
    orgs: { type: Array, default: [] },
    userPremium: { type: Boolean, default: false },
    userAvatar: { type: String, default: '' },
    userName: { type: String, default: '' }
  }

  tierGradients = {
    platinum: 'linear-gradient(135deg, rgba(168,85,247,0.15), rgba(139,92,246,0.08))',
    gold:     'linear-gradient(135deg, rgba(234,179,8,0.15), rgba(245,158,11,0.08))',
    silver:   'linear-gradient(135deg, rgba(192,192,192,0.12), rgba(156,163,175,0.06))',
    standard: 'linear-gradient(135deg, rgba(59,130,246,0.12), rgba(99,102,241,0.06))',
    premium:  'linear-gradient(135deg, rgba(234,179,8,0.12), rgba(245,158,11,0.06))',
    member:   'linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))'
  }

  switch() {
    const selected = this.selectorTarget.value
    const box = this.element

    if (selected.startsWith('organization_')) {
      const orgId = parseInt(selected.split('_')[1])
      const org = this.orgsValue.find(o => o.id === orgId)

      if (org) {
        const tier = org.tier || 'standard'
        box.style.background = this.tierGradients[tier] || this.tierGradients.standard

        // Update avatar
        if (org.avatar && this.hasAvatarImgTarget) {
          if (this.avatarImgTarget.tagName === 'IMG') {
            this.avatarImgTarget.src = org.avatar
            this.avatarImgTarget.className = 'org-logo org-logo--tiny max-h-6 max-w-[5rem] w-auto h-auto object-contain'
            this.avatarImgTarget.style.cssText = ''
          } else {
            const img = document.createElement('img')
            img.src = org.avatar
            img.className = 'org-logo org-logo--tiny max-h-6 max-w-[5rem] w-auto h-auto object-contain'
            img.dataset.postingAsTarget = 'avatarImg'
            this.avatarImgTarget.replaceWith(img)
          }
        } else if (this.hasAvatarImgTarget) {
          if (this.avatarImgTarget.tagName !== 'DIV') {
            const div = document.createElement('div')
            div.style.cssText = 'width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,0.08);display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,0.5);font-weight:700;font-size:16px;'
            div.dataset.postingAsTarget = 'avatarImg'
            div.textContent = org.name.charAt(0).toUpperCase()
            this.avatarImgTarget.replaceWith(div)
          } else {
            this.avatarImgTarget.textContent = org.name.charAt(0).toUpperCase()
          }
        }

        // Update tier badge
        if (this.hasTierBadgeTarget) {
          this.tierBadgeTarget.textContent = tier.charAt(0).toUpperCase() + tier.slice(1)
        }
      }
    } else {
      // Posting as user
      const userTier = this.userPremiumValue ? 'premium' : 'member'
      box.style.background = this.tierGradients[userTier]

      // Update avatar to user's avatar
      if (this.hasAvatarImgTarget) {
        if (this.userAvatarValue) {
          if (this.avatarImgTarget.tagName === 'IMG') {
            this.avatarImgTarget.src = this.userAvatarValue
            this.avatarImgTarget.className = 'w-10 h-10 rounded-full object-cover'
            this.avatarImgTarget.style.cssText = ''
          } else {
            const img = document.createElement('img')
            img.src = this.userAvatarValue
            img.className = 'w-10 h-10 rounded-full object-cover'
            img.dataset.postingAsTarget = 'avatarImg'
            this.avatarImgTarget.replaceWith(img)
          }
        } else {
          // No user avatar — show initial
          if (this.avatarImgTarget.tagName !== 'DIV') {
            const div = document.createElement('div')
            div.style.cssText = 'width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,0.08);display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,0.5);font-weight:700;font-size:16px;'
            div.dataset.postingAsTarget = 'avatarImg'
            div.textContent = (this.userNameValue || '?').charAt(0).toUpperCase()
            this.avatarImgTarget.replaceWith(div)
          } else {
            this.avatarImgTarget.textContent = (this.userNameValue || '?').charAt(0).toUpperCase()
          }
        }
      }

      if (this.hasTierBadgeTarget) {
        this.tierBadgeTarget.textContent = this.userPremiumValue ? 'Premium' : 'Member'
      }
    }
  }
}
